/** Plain text from HTML-ish Q&A fields for meta descriptions and JSON-LD. */
export function stripHtmlToText(raw) {
  if (raw == null) return '';
  let s = String(raw);
  s = s.replace(/<[^>]+>/g, ' ');
  s = s.replace(/\s+/g, ' ').trim();
  return s;
}

export function truncateText(text, maxLen = 155) {
  const t = (text || '').trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, maxLen - 1).trim()}…`;
}

export function buildQuestionSeoTitle(item) {
  const q = stripHtmlToText(item?.question);
  const topic = item?.topic ? String(item.topic).trim() : '';
  if (!q) return 'Q&A on QnaRead';
  const head = truncateText(q, 58);
  if (topic) return `${head} — ${topic}`;
  return head;
}

export function buildQuestionSeoDescription(item) {
  const answer = stripHtmlToText(item?.answer);
  const topic = item?.topic ? `Topic: ${item.topic}. ` : '';
  const notebook = item?.notebookTitle ? `From notebook “${item.notebookTitle}”. ` : '';
  return truncateText(`${topic}${notebook}${answer || 'Structured Q&A on QnaRead.'}`, 160);
}

export function publicQuestionPath(id) {
  return `/q/${id}`;
}
